import { Form } from "semantic-ui-react";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { initialValues, validationSchema } from "./PostForm.form";
import { useAuth } from "../../../../hooks";
import { Post } from "../../../../api";
import { CustomQuillEditor } from "../../../../components/Shared";

const postController = new Post();

export function PostForm(props) {
  const { subjectsOptions, onReload, onClose } = props;
  const { accessToken } = useAuth();

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        console.log("Form value:", formValue);
        const response = await postController.createPost(
          accessToken,
          formValue
        );
        Swal.fire({
          icon: "success",
          title: "Publicación creada",
          text: "Tu publicación ha sido creada y está pendiente de aprobación por un administrador.",
          confirmButtonText: "Entendido",
          confirmButtonColor: "#2185d0",
        });
        onClose();
      } catch (error) {
        console.error(error);
      }
    },
  });

  return (
    <Form onSubmit={formik.handleSubmit}>
      <Form.Select
        className="edunova-select"
        fluid
        name="type"
        label="Tipo de publicación"
        options={[
          { key: "question", text: "Pregunta", value: "question" },
          { key: "debate", text: "Debate", value: "debate" },
        ]}
        onChange={(e, { value }) => formik.setFieldValue("type", value)}
        value={formik.values.type}
        error={formik.errors.type}
      />
      <Form.Select
        className="edunova-select"
        name="subjectId"
        label="Asignatura"
        options={subjectsOptions}
        onChange={(e, { value }) => formik.setFieldValue("subjectId", value)}
        value={formik.values.subjectId}
        error={formik.errors.subjectId}
      />
      <Form.Input
        name="title"
        label="Título"
        onChange={formik.handleChange}
        value={formik.values.title}
        error={formik.errors.title}
      />
      <CustomQuillEditor
        className="media-slide__input-content"
        value={formik.values.content}
        onChange={(value) => formik.setFieldValue("content", value)}
      />
      <Form.Button type="submit" primary fluid loading={formik.isSubmitting}>
        Guardar publicación
      </Form.Button>
    </Form>
  );
}
